import React from "react";
import "./SortableTableHeader.css";

const SortableTableHeader = ({ columns, sortConfig, onSort }) => (
  <thead>
    <tr>
      {columns.map((column) => (
        <th
          key={column.key}
          aria-sort={
            sortConfig.key === column.key
              ? sortConfig.direction
              : undefined
          }
          className={column.type === "currency" ? "text-end" : undefined}
        >
          {column.sortable === false ? (
            column.label
          ) : (
            <button
              type="button"
              className="job-schedule-sort-button"
              onClick={() => onSort(column.key)}
              title={`Sort by ${column.label}`}
            >
              <span>{column.label}</span>
              <i
                className={`bi ${
                  sortConfig.key !== column.key
                    ? "bi-chevron-expand"
                    : sortConfig.direction === "ascending"
                      ? "bi-chevron-up"
                      : "bi-chevron-down"
                }`}
                aria-hidden="true"
              />
            </button>
          )}
        </th>
      ))}
    </tr>
  </thead>
);

export default SortableTableHeader;

